export default __webpack_public_path__ + "static/media/cog-icon.5523f255.svg";